import ListItem from '@zenbusiness/zui/ListItem';
import { superstyled } from '@zenbusiness/zui/styles';

export const ExtraInfoCardListItem = superstyled({
  name: 'ExtraInfoCard',
  slot: 'ListItem',
  tag: ListItem,
  styles: ({ theme }) => ({
    borderColor: theme.palette.border.main,
    fontWeight: 'normal',
    padding: `${theme.spacing(2)} 0`,

    '&:last-child': {
      borderBottom: 0
    }
  })
});
